import { REPORTS_CONFIG } from '../../constants/reportsConstants';
import { convertTimestampsToUnix } from '../../dateUtils';

// Helper to get only the labels for the TabsMenu where component is not null
export const validReports = REPORTS_CONFIG.filter((report) => report.component !== null);
export const tabsMenuOptions = validReports.map((report) => report.label);

export const formatTicketData = (data, docId) => {
  // Convert the total and laborCost to numbers if they are strings
  const total = typeof data.total === 'string' ? data.total : data.total || 0;
  const laborCost = typeof data.laborCost === 'string' ? data.laborCost : data.laborCost || 0;
  // Convert all Timestamp fields to Unix timestamps
  const convertedData = convertTimestampsToUnix(data);

  return {
    id: docId,
    ...convertedData,
    total: total,
    laborCost: laborCost,
  };
};
